import { getAmplitudeInstance } from '../amplitudeHelpers';
import ExploreMapPinInteraction from '../enums/ExploreMapPinInteraction';
import ExploreMapPinType from '../enums/ExploreMapPinType';
import MapLocation from '../enums/MapLocation';

type logExploreMapPinSelectedParams = {
  action_taken: ExploreMapPinInteraction;
  map_location?: MapLocation;
  pin_type: ExploreMapPinType;
  trail_id?: number;
};

/**
 * User clicks or hovers on an explore map trail or trailhead pin
 * @param params - Attributes to log with the amplitude event
 * @param params.action_taken - The method by which the user interacted with a pin
 * @param params.map_location - Location of explore map
 * @param params.pin_type - The type of pin that the user interacted with (trailhead or trail).
 * @param params.trail_id - The id of the trail
 */
const logExploreMapPinSelected = ({ action_taken, map_location, pin_type, trail_id }: logExploreMapPinSelectedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'explore map pin selected',
    { 'action taken': action_taken, 'map location': map_location, 'pin type': pin_type, 'trail id': trail_id },
    callback
  );
};

export default logExploreMapPinSelected;
